import { ClvrScreenControlDataTypeDto } from '../Types/ClvrScreenControlDataTypeDto'
import { ScreenControlDataTypeData } from '../Types/ScreenControlDataTypeData'
import { ClvrScreenControlHeadersLabelsEnum } from '../Components/ClvrScreenControlPlanningTable/enum'
import {
    AGGREGATED_DATA_TYPES,
    TRIGRAM_DATA_TYPES,
} from '../Components/ClvrScreenControlPlanningTable/const/ClvrScreenControlHeadersEnumRefLabels'

export default class ClvrScreenControlDataTypeDataHandler {
    public constructor(private dataType: ScreenControlDataTypeData) {}

    public static formatDataTypes(
        dataTypes: ScreenControlDataTypeData[],
        isTrigramMode = false,
        isDataAggregated = false,
    ): ScreenControlDataTypeData[] {
        if (isTrigramMode) {
            dataTypes = this.formatDataTypeTrigram(dataTypes)
        }
        if (isDataAggregated) {
            dataTypes = this.formatDataTypeAggregated(dataTypes)
        }
        return dataTypes
    }

    private static formatDataTypeTrigram(dataTypes: ScreenControlDataTypeData[]): ScreenControlDataTypeData[] {
        return dataTypes.map(dataType => {
            if (TRIGRAM_DATA_TYPES.includes(dataType.name as ClvrScreenControlHeadersLabelsEnum)) {
                return {
                    ...dataType,
                    name: `${dataType.name}_avatar`,
                }
            }
            return dataType
        })
    }

    private static formatDataTypeAggregated(dataTypes: ScreenControlDataTypeData[]): ScreenControlDataTypeData[] {
        const materialChildren =
            dataTypes.find(dt => dt.name === ClvrScreenControlHeadersLabelsEnum.MATERIAL)?.dataTypeChildren || []

        return dataTypes.flatMap(dataType => {
            if (!AGGREGATED_DATA_TYPES.includes(dataType.name as ClvrScreenControlHeadersLabelsEnum)) {
                return [dataType]
            }
            if (dataType.name === ClvrScreenControlHeadersLabelsEnum.INTERVENTION) {
                return [
                    {
                        ...dataType,
                        name: ClvrScreenControlHeadersLabelsEnum.INTERVENTION_AND_MATERIAL,
                        //we need to move the children datatype list from MATERIAL to INTERVENTION_AND_MATERIAL
                        dataTypeChildren: [
                            ...(dataType.dataTypeChildren || []),
                            ...materialChildren.map(child => ({
                                ...child,
                                name: `intervention_and_${child.name}` as ClvrScreenControlHeadersLabelsEnum,
                            })),
                        ],
                    },
                ]
            }
            return []
        }) as ScreenControlDataTypeData[]
    }
    public static getNameAndChildrenNameFromDataType(dataType: ScreenControlDataTypeData): string[] {
        return [dataType.name].concat(dataType.dataTypeChildren?.map(child => child.name) ?? [])
    }

    public static getNameAndChildrenNameFromDataTypes(dataTypes: ScreenControlDataTypeData[]): string[] {
        return dataTypes.flatMap(dataType =>
            ClvrScreenControlDataTypeDataHandler.getNameAndChildrenNameFromDataType(dataType),
        )
    }

    public toDto(): ClvrScreenControlDataTypeDto {
        return {
            dataTypeId: this.dataType.id || null,
            name: this.dataType.name,
            parentDataTypeId: this.dataType.parentDataTypeId || null,
            rank: this.dataType.rank,
            isVisible: this.dataType.enable,
            creation_date: this.dataType.creationDate,
            update_date: this.dataType.updateDate,
            _dataTypeChildren:
                this.dataType.dataTypeChildren?.map(dataType =>
                    new ClvrScreenControlDataTypeDataHandler(dataType).toDto(),
                ) || [],
        }
    }
}
